import type IProduct from 'interfaces/IProduct';

export interface WizardLoading {
  active: boolean;
  percent: number;
}

export interface WizardStateValue {
  step: number;
  selected: number;
  loading: WizardLoading;
  product: IProduct | null;

  nextStep: () => void;
  previousStep: () => void;
  resetWizard: (initialStep?: number) => void;
  setSelected: (value: number) => void;
  resetSelected: (initialSelected?: number) => void;
  updateLoading: (percent: number) => void;
  resetLoading: () => void;
  setProduct: (product: IProduct) => void;
  resetProduct: () => void;
}

export const DEFAULT_LOADING: WizardLoading = {
  active: false,
  percent: 0
};
